const state = {
  locations:{}
}

export default state
